import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Import Home Button
import AccountHomeButton from "../pages/Auth/account-home-button";

const EmployeeRegister = () => {
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);

  

  const validation = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      try {
        const { data } = await api.post("https://payweek.com/api/send-otp-emp", values);
        //const { data } = await api.post("http://localhost:5000/send-otp-emp", values);
        alert("OTP sent successfully!");
        setIsSubmitted(true);
        navigate("/set-password", { state: { userId: data.userId } });
      } catch (err) {
        alert("Failed to send OTP.");
      }
    },
  });

  return (
    <section className="vh-100">
    <AccountHomeButton />
      <Container className="emp-otp-cont">
        <Row className="justify-content-center">
          <Col lg="5">
            <Card className="account-card">
              <CardBody>
                <h4 className="font-weight-bold text-center otp-header-emp">First Time User</h4>
                <p className="text-muted text-center empotp-text">Enter your email to receive an OTP.</p>

                <Form onSubmit={validation.handleSubmit}>
                  <div className="form-group">
                    <Input
                      name="email"
                      placeholder="Enter Email"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={validation.touched.email && validation.errors.email ? true : false}
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                    ) : null}
                  </div>

                  <div className="d-grid mt-3">
                    <Button type="submit" className="btn btn-primary" disabled={isSubmitted}>
                      Send OTP
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EmployeeRegister;
